// Lista de pedidos. MVP: muestra todos los pedidos pendientes (status=1).
// Sin filtros ni búsqueda en esta primera versión — viene del plan: "GET /pedidos
// → cards · tap → /pedido/:id". Los filtros del mockup son material de pulido
// posterior si el operario los pide.

import { apiGet } from '../api/client.js';
import { icon } from '../components/icons.js';
import { fontScaleButtonHTML } from '../components/font-scale.js';
import { getUser, isAdmin, logout } from '../state/auth.js';
import { navigate } from '../router.js';

const escapeHtml = (s) => String(s ?? '').replace(/[&<>"']/g,
  c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

function fmtFecha(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return ''; }
}

function cardHTML(p) {
  return `
    <a class="pedido-card --pendiente" href="#/pedido/${p.pedido_id}">
      <div class="head">
        <span class="cliente">${escapeHtml(p.cliente_nombre || '— sin cliente —')}</span>
        <span class="badge --neutral">Pendiente</span>
      </div>
      <div class="sub">
        <span class="ref">${escapeHtml(p.referencia)}</span>
        <span>${escapeHtml(fmtFecha(p.fecha))}</span>
      </div>
      <span class="meta">
        <span>${p.num_lineas} ${p.num_lineas === 1 ? 'línea' : 'líneas'}</span>
      </span>
    </a>`;
}

export function pedidosView() {
  return {
    async mount(root) {
      const user = getUser();
      const userName = user?.fullname || user?.username || 'Operario';

      root.innerHTML = `
        <div class="app">
          <header class="topbar">
            <h1>Pedidos
              <span class="subtitle">${escapeHtml(userName)}</span>
            </h1>
            ${fontScaleButtonHTML()}
            ${isAdmin() ? `<button class="iconbtn" id="btn-admin" title="Admin (productos / cajas)" aria-label="Admin">${icon('settings', { size: 22 })}</button>` : ''}
            <button class="iconbtn" id="btn-logout" title="Salir" aria-label="Salir">${icon('log-out', { size: 22 })}</button>
          </header>
          <main class="content" id="content">
            <p style="color:var(--c-fg-muted);">Cargando pedidos…</p>
          </main>
        </div>`;

      root.querySelector('#btn-admin')?.addEventListener('click', () => navigate('#/admin'));
      root.querySelector('#btn-logout').addEventListener('click', async () => {
        await logout();
        navigate('#/login', { replace: true });
      });

      const content = root.querySelector('#content');
      try {
        const list = await apiGet('/pedidos?status_filter=1&limit=50');
        if (!Array.isArray(list) || list.length === 0) {
          content.innerHTML = `
            <div class="empty-state">
              <div class="icon" style="font-size: 3rem; display: flex; justify-content: center;">${icon('package', { size: 48 })}</div>
              <h2 style="margin:0;font-size:var(--fs-lg);">Sin pedidos pendientes</h2>
              <p style="margin:0;">Cuando llegue un nuevo pedido aparecerá aquí.</p>
            </div>`;
          return;
        }
        content.innerHTML = `
          <div class="badge --neutral" style="align-self:flex-start;">
            ${list.length} ${list.length === 1 ? 'pedido' : 'pedidos'} pendientes
          </div>
          <div class="pedidos-list">${list.map(cardHTML).join('')}</div>`;
      } catch (e) {
        if (e?.status === 401) return;  // el guard ya redirige
        content.innerHTML = `
          <div class="alert --error" style="margin-top:1rem;">
            <div class="ico">${icon('octagon-x', { size: 24 })}</div>
            <div class="body">
              <strong>No se pudieron cargar los pedidos</strong>
              <span>${escapeHtml(e?.message || 'Error desconocido')}</span>
            </div>
          </div>`;
      }
    },
    unmount() { /* nada que limpiar */ },
  };
}
